module.exports = __webpack_public_path__ + "img/jobs_i7.3b7cfa49.png";